const formatNumber = n => {
  n = n.toString();
  return n[1] ? n : '0' + n;
};

// 扩展Date对象原型,添加日期格式化函数
/* 使用方法
 * date.Format('yyyy-MM-dd hh:mm:ss')
 * */
Date.prototype.Format = function(number, format = 'Y-M-D h:m:s') {
  let formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
  let returnArr = [];

  let date = new Date(number);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));

  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));

  for (let i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }
  return format;
};

// 创建UUID
const generateUUID = () => {
  let d = new Date().getTime();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};

// 检验密码大于8位且有数字与字母
const checkPassword = str => {
  let reg = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/);
  if (str.length > 8 && reg.test(str)) {
    return true;
  } else {
    return false;
  }
};
// 清除全部空格
const removeAllSpace = str => {
  return str.replace(/\s+/g, '');
};
// 去除字符串前后的空格
const trim = str => {
  return str.replace(/(^\s+)|(\s+$)/g, '');
};

// 手机号码验证
const verifyPhone = num => {
  if (!num) {
    return false;
  } else {
    // return true;
  }
  let phoneNum = removeAllSpace(num);
  let reg = /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/; //验证规则，[34578]之间不需要|
  let flag = reg.test(phoneNum);
  return flag;
};

// 验证证件号（字母或数字）
const verifyIdNumber = num => {
  let reg = /^[0-9a-zA-Z]+$/;
  return reg.test(num);
};

// 邮箱 验证
const verifyEmail = email => {
  let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
  return reg.test(email);
};

// 身份证号码简单验证
const verifyIdCard = idCard => {
  // 15位和18位身份证号码的正则表达式
  let regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;

  // 如果通过该验证，说明身份证格式正确，但准确性还需计算
  if (regIdCard.test(idCard)) {
    if (idCard.length == 18) {
      let idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); // 将前17位加权因子保存在数组里
      let idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
      let idCardWiSum = 0; // 用来保存前17位各自乖以加权因子后的总和
      for (let i = 0; i < 17; i++) {
        idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
      }
      let idCardMod = idCardWiSum % 11; // 计算出校验码所在数组的位置
      let idCardLast = idCard.substring(17); // 得到最后一位身份证号码
      // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
      if (idCardMod == 2) {
        if (idCardLast == 'X' || idCardLast == 'x') {
          return true;
        } else {
          return false;
        }
      } else {
        // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
        if (idCardLast == idCardY[idCardMod]) {
          return true;
        } else {
          return false;
        }
      }
    } else if (idCard.length == 15) {
      return true;
    }
  } else {
    return false;
  }
};


// 生成ID随机数
const randomString = () => {
  return (Date.now() * 1000 + Math.floor(Math.random() * 1000)).toString(36);
};

// 文件file转成Blog路径
const createObjectURL = files => {
  let urls = [];
  for (let item of files) {
    let url = URL.createObjectURL(item);
    urls.push(url);
  }
  return urls;
};

// 单个文件file转成Blog路径并返回文件类型
const FileUrlAndType = files => {
  let urls = [];
  for (let item of files) {
    const url = URL.createObjectURL(item);
    const suffix = fileSuffix(item.type);
    const temp = {
      url,
      suffix
    };
    urls.push(temp);
  }
  return urls;
};

// 替换emoji表情|特殊符号为空
const replaceEmoji = str => {
  let val = str.replace(
    /[^\u4e00-\u9fa5a-zA-Z\d,.。,\]`[;'，.*+~!@#$%^&()_+{}|":<>?·\-=【】、；’+*~！@#￥%……&（）——+|：“《》？…]+/gi,
    ''
  );
  return val;
};

const fileSuffix = type => {
  switch (type) {
    case 'image/png':
    case 'image/jpeg':
      return '.JPG';
    case 'photo':
      return '.JPG';
      break;
    case 'MP4':
      return '.MP4';
    case 'video/mp4':
      return '.MP4';
      break;
    case 'MP3':
      return 'MP3';
    case 'audio/mp3':
      return '.MP3';
      break;
    case 'PDF':
      return '.PDF';
    case 'application/pdf':
      return '.PDF';
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return '.DOC';
  }
};

const getFileType = file => {
  if (file.match('.JPG') || file.match('.PNG')) {
    return 'photo';
  }
  if (file.match('.MP3')) {
    return 'vioce';
  }
  if (file.match('.MP4')) {
    return 'video';
  }
  if (file.match('.PDF')) {
    return 'pdf';
  } else {
    return 'document';
  }
};

const prefixInteger = (num, length)=> {
  return (Array(length).join('0') + num).slice(-length);
}

// 验证数字
const verifyNumber = num => {
  let reg = /^[0-9]+$/
  return reg.test(num)
}

const formatTime = (ms, format = 'hh:mm:ss') => {
  ms = Math.min(ms, 356400000);
  ms = Math.max(ms, 0);
  let M, h, m, s, hh, mm, ss;
  s = ~~(ms / 1000);
  m = ~~(s / 60);
  h = ~~(m / 60);
  ss = s % 60;
  mm = m % 60;
  hh = h % 60;
  let o = {
    'h+': h.toString(),
    'm+': mm.toString(),
    's+': ss.toString(),
    'M+': m.toString()
  };
  for (let k in o) {
    let reg = new RegExp(`(${ k })`);
    if (reg.test(format)) {
      let replacement = o[k].padStart(RegExp.$1.length, '0');
      format = format.replace(reg, replacement);
    }
  }
  return format;
}

Array.prototype.contains = function(obj) {
  var index = this.length;
  while (index--) {
    if (this[index] === obj) {
      return true;
    }
  }
  return false;
};
export {
  generateUUID,
  createObjectURL,
  verifyIdCard,
  verifyPhone,
  verifyEmail,
  replaceEmoji,
  randomString,
  FileUrlAndType,
  fileSuffix,
  trim,
  getFileType,
  verifyIdNumber,
  prefixInteger,
  verifyNumber,
  formatTime
};
